import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../EditWidget/EditWidget.scss';

const ReactSkeleton = () => {
	return <Skeleton className="w-100 skeleton-default" />;
};

ReactSkeleton.Icon = () => <Skeleton className="skeleton-icon" />;

ReactSkeleton.Title = () => <Skeleton className="skeleton-title" />;

ReactSkeleton.Link = () => <Skeleton className="skeleton-link" />;

ReactSkeleton.HeaderLayout = () => (
	<div className="d-flex align-items-center skeleton-header-layout">
		<ReactSkeleton.Icon />
		<ReactSkeleton.Title />
	</div>
);

ReactSkeleton.LinksLayout = () => {
	const links = Array(5).fill(null);

	return (
		<div className="d-flex flex-column skeleton-links-layout">
			{links.map((_, index) => (
				<ReactSkeleton.Link key={index} />
			))}
		</div>
	);
};

export default ReactSkeleton;
